import { FormElement, FormType } from "@kolibrisoftware/customerportal-api";
import {
  ContentSection,
  ContentSectionSize,
} from "@kolibrisoftware/customerportal-ui";
import useElementTranslations from "hooks/useElementTranslations";
import { useTheme } from "injectors/theme";
import useElementData from "modules/questionnaire/hooks/useElementData";
import { FC } from "react";
import { useStyles } from "./styles";
import { selectQuestionnaireForm } from "store/questionnaire/selectors";
import { useSelector } from "store/helpers";
import classNames from "classnames";

type Props = {
  partStructure: FormElement;
  children?: React.ReactNode;
};

const FormPart: FC<Props> = ({ partStructure, children }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const partDetails = useElementData(partStructure.id);
  const partTranslations = useElementTranslations(partDetails);
  const form = useSelector(selectQuestionnaireForm);
  const isPersonalia = form.type === FormType.PersonalDetails;

  return (
    <>
      {!isPersonalia && (
        <ContentSection size={ContentSectionSize.Full}>
          <h2 className={styles.formPartTitle}>{partTranslations?.title}</h2>
          {!!partTranslations?.text && (
            <div
              className={styles.formPartBody}
              dangerouslySetInnerHTML={{ __html: partTranslations.text }}
            />
          )}
        </ContentSection>
      )}
      {children}
    </>
  );
};

export { FormPart };
